var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-product-carousel',{attrs:{"id":_vm.id,"title":_vm.title,"products":_vm.products},on:{"buy-product":function($event){return _vm.handleAdditionalSell($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }